import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Select, Button, Modal } from "antd";
import isEmpty from "lodash/isEmpty";

import { getAllUsers } from "services/remanentCalls";
import { addOrDeleteParticipantInQuickGroupChatUpdate } from "services/redux/instanceSpecialChat/action";
const { Option } = Select;

export default function GroupChatMembersEdit({
  openChatParticipantEdit,
  setOpenChatParticipantEdit,
  groupName,
  userListTo,
  userListCc,
  dMailMessageCenterId,
}) {
  const [selectedGroupDataToBeUpdated, setGroupDataToBeUpdate] = useState();
  const dispatch = useDispatch();

  const [form4] = Form.useForm();

  const [userListing, setUserListing] = useState([]);

  const { instanceSpecialChatUpdate, instanceSpecialChatUpdateLoading } =
    useSelector((state) => state.instanceSpecialChatReducer);

  const fetchUserListing = async () => {
    const resp = await getAllUsers().catch((err) => {
      //  message.error("Failure");
    });
    if (resp && resp.status === 200) {
      setUserListing(resp.data);
    }
  };

  useEffect(() => {
    if (isEmpty(userListing)) {
      fetchUserListing();
    }
  }, []);

  useEffect(() => {
    form4.setFieldsValue({
      groupName,
      userListTo: userListTo
        ? userListTo.map((u) => u.participantId || u) // handles both array of objects and array of ids
        : [],
      userListCc: userListCc ? userListCc.map((u) => u.participantId || u) : [],
    });
  }, [groupName, userListTo, userListCc]);

  const [submitted, setSubmitted] = useState(false);

  const handleFinish = (values) => {
    var valuesId = {
      tos: values.userListTo
        ? values.userListTo.map((id) => ({ participantId: id }))
        : [],
      cCs: values.userListCc
        ? values.userListCc.map((id) => ({ participantId: id }))
        : [],
    };
    setSubmitted(true); // Mark as submitted
    dispatch(
      addOrDeleteParticipantInQuickGroupChatUpdate(
        dMailMessageCenterId,
        valuesId
      )
    );
  };

  // Watch for loader to become false after submit
  useEffect(() => {
    if (submitted && !instanceSpecialChatUpdateLoading) {
      setOpenChatParticipantEdit(false);
      setSubmitted(false); // Reset for next submit
    }
  }, [instanceSpecialChatUpdateLoading, submitted]);

  return (
    <>
      {" "}
      <Modal
        // visible={createGroupModal}
        title={`${"Update Your Group"}`}
        // onCancel={() => setCreateGroupModal(false)}
        footer={null}
        height={300}
        visible={openChatParticipantEdit}
        onCancel={() => setOpenChatParticipantEdit(false)}
      >
        <Form form={form4} onFinish={handleFinish}>
          <Form.Item
            name="groupName"
            label="Group Name"
            rules={[{ required: true }]}
          >
            <Input disabled placeholder="Name of your group" />
          </Form.Item>

          <Form.Item
            name="userListTo"
            label="To Users"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Users"
              allowClear
              autoComplete="off"
              mode="multiple"
              optionFilterProp="label"
            >
              {!isEmpty(userListing) &&
                userListing?.map((user, index) => {
                  return (
                    <Option
                      value={user?.appUserId}
                      key={index}
                      label={[user.fullName, user.userName]}
                    >
                      {user?.fullName} [{user?.userName.toUpperCase()}]
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>

          <Form.Item
            name="userListCc"
            label="CC Users"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Users"
              allowClear
              autoComplete="off"
              mode="multiple"
              optionFilterProp="label"
            >
              {!isEmpty(userListing) &&
                userListing?.map((user, index) => {
                  return (
                    <Option
                      value={user?.appUserId}
                      key={index}
                      label={[user.fullName, user.userName]}
                    >
                      {user?.fullName} [{user?.userName.toUpperCase()}]
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={instanceSpecialChatUpdateLoading}
          >
            {isEmpty(selectedGroupDataToBeUpdated) ? "Submit" : "Update"}
          </Button>
        </Form>
      </Modal>
    </>
  );
}
